// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ICreateAnswerRequest,
  TCreateAnswerModel,
  IMappers,
  TCreateAnswerResponse,
  ICreateAnswerResponse,
  ICreateAnswerResponseError,
} from './types';

export const defaultConfig: TCreateAnswerModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-reviews',
  pathApi: '/v1/create-answer/',
  requestType: 'json',
} as TCreateAnswerModel;

export function createCreateAnswerModel(parameters: ICreateAnswerRequest): TCreateAnswerModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICreateAnswerOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ICreateAnswerRequest;
}

export async function fetchCreateAnswer<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICreateAnswerOptions<TResponse200, TResponse400>): Promise<TCreateAnswerResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createCreateAnswerModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateAnswerResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as ICreateAnswerResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TCreateAnswerResponse;
}
